module.exports = __webpack_public_path__ + "785bd9c7279bd279fed1e35c5bf97918.pdf";